export class SchulbuchContent extends HTMLElement {
  constructor() {
    super();
    this.events = ["change", "submit"];
    this.addListener();
  }

  get baseUrl() {
    return this.dataset["schulbuchBaseUri"] || null;
  }

  get ladeindikator() {
    return this.querySelector("merkzettel-ladeindikator");
  }

  get notificationContainer() {
    return this.querySelector(".notification-container");
  }

  get merkzettelWarenkorb() {
    return this.querySelector("merkzettel-warenkorb");
  }

  get aktiveArtikel() {
    return this.querySelectorAll("input[name='artikelnummer']:checked");
  }

  connectedCallback() {
    __webpack_public_path__ = `${this.dataset["assetBaseUri"]}/schulbuch-content/`;
  }

  disconnectedCallback() {
    this.removeListener();
  }

  addListener() {
    for (const event of this.events) {
      this.addEventListener(event, this);
    }
  }

  removeListener() {
    for (const event of this.events) {
      this.removeEventListener(event, this);
    }
  }

  // https://gomakethings.com/the-handleevent-method-is-the-absolute-best-way-to-handle-events-in-web-components/
  handleEvent(event) {
    this[`handle${event.type}`](event);
  }

  async handlechange(event) {
    if (this.changeHandler) {
      return this.changeHandler.change(event);
    }
    const { ChangeHandler } = await import("./ChangeHandler.js");
    this.changeHandler = new ChangeHandler(this);
    this.changeHandler.change(event);
  }

  async handlesubmit(event) {
    if (event.target.dataset.update !== "content") {
      return;
    }
    event.preventDefault();
    if (this.submitHandler) {
      return this.submitHandler.submit(event);
    }
    const { SubmitHandler } = await import("./SubmitHandler.js");
    this.submitHandler = new SubmitHandler(this);
    this.submitHandler.submit(event);
  }
}

if (!customElements.get("schulbuch-content")) {
  customElements.define("schulbuch-content", SchulbuchContent);
}
